import * as S from './CaptivateAllImageModalLoader.styles';
import {FlexItem} from '../../../../CommonStyleUtils/dwebCommon.styles';

const CaptivateAllImageLeftLoader = ({loaderStyles = {}}) => (
  <>
    <S.LeftLoaderMainWrapper {...loaderStyles}>
      <S.HeaderBlockDiv>
        <S.HeaderLeftBlockLoader />
        <S.LeftHeaderLoader />
      </S.HeaderBlockDiv>

      <FlexItem>
        <S.FirstBlockWrapper>
          <S.FirstImageLoaderLoader />
          <S.SecondImageLoaderLoader />
        </S.FirstBlockWrapper>
        <S.FirstBlockWrapper>
          <S.SecondImageLoaderLoader />
          <S.FirstImageLoaderLoader />
        </S.FirstBlockWrapper>
      </FlexItem>
    </S.LeftLoaderMainWrapper>
  </>
);

export default CaptivateAllImageLeftLoader;
